import React from "react";

/**
 * Reusable pill-style tab strip.
 *
 * Props:
 *   tabs      - [{ label, value?, icon? }] or [string] — if value omitted, uses index
 *   active    - currently active tab value (index by default)
 *   onChange  - (value) => void
 */
const TabStrip = ({ tabs = [], active, onChange }) => (
  <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit mb-6">
    {tabs.map((tab, index) => {
      const label = typeof tab === "string" ? tab : tab.label;
      const icon = typeof tab === "string" ? null : tab.icon;
      const value = typeof tab === "string" ? index : (tab.value ?? index);
      const isActive = active === value;
      return (
        <button
          key={value}
          onClick={() => onChange(value)}
          className={`flex items-center gap-2 px-6 py-2 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none ${
            isActive
              ? "bg-white text-gray-900 shadow-sm font-semibold"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {icon && <span className="text-base">{icon}</span>}
          {label}
        </button>
      );
    })}
  </div>
);

export default TabStrip;
